export type FormData<T = any> = {
    cancel: boolean;
    modified: boolean;
    saving: boolean;
    data: T;
    error?: any;
    type?: string;
};

export function cancelData(f: any) {
    f((prev: any) => {
        prev.cancel = true;
        return { ...prev };
    });
}

export function emptyFormData(t?: string): FormData {
    return { cancel: false, modified: false, saving: false, data: {}, type: t };
}

export function errorData(response: any, setData: any) {
    setData((prev: any) => {
        return { ...prev, error: response.errors || [], saving: false };
    });
}

export function saveData(setData: any, onSave: any) {
    setData((prev: any) => {
        if (prev.saving) return prev;
        prev.saving = true;
        onSave(prev.data, setData, prev.type);
        return { ...prev };
    });
}

export const isValidUrl = (urlString: string): boolean => {
    try {
        const url = new URL(urlString);

        // Must use http or https protocol
        if (!['http:', 'https:'].includes(url.protocol)) {
            return false;
        }

        // Must have a non-empty hostname
        if (!url.hostname) {
            return false;
        }

        // Hostname must contain at least one dot and valid TLD
        const hostnameParts = url.hostname.split('.');
        if (hostnameParts.length < 2) {
            return false;
        }

        // Each part of the hostname must be valid
        const hostnameRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;
        if (
            !hostnameParts.every(
                part =>
                    part &&
                    part.length <= 63 &&
                    !part.startsWith('-') &&
                    !part.endsWith('-') &&
                    hostnameRegex.test(part)
            )
        ) {
            return false;
        }

        // Basic check for valid TLD (at least 2 chars)
        const tld = hostnameParts[hostnameParts.length - 1];
        if (tld.length < 2) {
            return false;
        }

        return true;
    } catch (e) {
        return false;
    }
};
